import { makeStyles, Theme, createStyles } from '@material-ui/core'
import colors from '../../../styles/colors'
import fonts from '../../../styles/fonts'
import palette from '../../../styles/palette'

/**
 * Banners de página. Os gradientes reproduzem o mockup Lovable:
 * - evento (`small`):  brand -> brandDeep, texto branco;
 * - aluno (`student`): studentBannerFrom -> studentBannerTo, texto brandDark.
 */
export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    bigBanner: {
      width: '100%',
      height: '27.938em',
      backgroundColor: colors.white,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
    },
    mediumBanner: {
      width: '100%',
      height: '19em',
      backgroundColor: colors.white,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      [theme.breakpoints.between('xs', 'lg')]: {
        fontSize: 'x-small',
      },
    },
    smallBanner: {
      width: '100%',
      height: '8.5em',
      borderRadius: palette.radius,
      overflow: 'hidden',
      background: `linear-gradient(90deg, ${palette.brand} 0%, ${palette.brandDeep} 100%)`,
      [theme.breakpoints.between('xs', 'lg')]: {
        width: '100%',
      },
    },
    studentBanner: {
      width: '100%',
      height: '8.5em',
      borderRadius: palette.radius,
      overflow: 'hidden',
      background: `linear-gradient(90deg, ${palette.studentBannerFrom} 0%, ${palette.studentBannerTo} 100%)`,
    },
    iconBanner: {
      width: '100%',
      height: '8em',
      background: `linear-gradient(90deg, ${palette.studentBannerFrom} 0%, ${palette.studentBannerTo} 100%)`,
      display: 'flex',
      alignItems: 'center',
      borderRadius: palette.radius,
      padding: '0 16px',
    },
    gridIconBanner: {
      height: '8em',
      display: 'flex',
      alignItems: 'center',
    },
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    iconElement: {
      marginRight: '16px',
      fontSize: '2em',
      color: colors.purplePrimary,
    },
    titleIconBanner: {
      fontSize: '1.25em !important',
      color: colors.blueDark,
      fontWeight: 600,
    },
    titleBigBanner: {
      fontSize: '3rem !important',
      color: colors.white,
      fontWeight: 600,
    },
    titleMediumBanner: {
      fontSize: '2.5rem !important',
      color: colors.white,
      fontWeight: 600,
    },
    titleSmallBanner: {
      fontSize: '1.875rem !important',
      color: colors.white,
      fontWeight: 600,
    },
    subtitleBanner: {
      fontSize: '0.875rem !important',
      color: colors.white,
      fontWeight: 500,
      marginTop: '12px !important',
      fontFamily: fonts.interComponent,
    },
    containerBanner: {},

    gridBigBanner: {
      height: '27.938em',
      display: 'flex',
      alignItems: 'center',
    },
    gridMediumBanner: {
      height: '19em',
      display: 'flex',
      alignItems: 'center',
    },
    gridSmallBanner: {
      height: '8.5em',
      display: 'flex',
      alignItems: 'center',
    },
    divider: {
      backgroundColor: colors.purpleDivDark,
      height: 3,
      width: 72,
      borderRadius: 999,
    },
    dividerLight: {
      backgroundColor: colors.lilacDarkMedium,
      height: 3,
      width: 72,
      borderRadius: 999,
    },
    dividerNew: {
      marginTop: '24px !important',
      marginBottom: '24px !important',
      backgroundColor: colors.purpleNewDivider,
      height: 4,
      width: 72,
      borderRadius: 999,
    },
    smallContainer: {
      display: 'flex',
      alignItems: 'center',
      width: '92% !important',
    },
    studentContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '95% !important',
    },
    subStudentContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    titleStudentBanner: {
      fontSize: '1.5rem !important',
      color: colors.blueDark,
      fontWeight: 700,
      lineHeight: '1.25 !important',
    },
    subtitleStudentBanner: {
      fontSize: '0.875rem !important',
      color: colors.blackMedium,
      fontWeight: 600,
      marginTop: '0px !important',
      marginBottom: '4px !important',
      fontFamily: fonts.interComponent,
    },
    subSubtitleStudentBanner: {
      fontSize: '0.8125rem !important',
      color: colors.grayMedium,
      fontWeight: 500,
      fontFamily: fonts.interComponent,
    },
    studentAvatar: {
      marginRight: '20px',
    },
  }),
)
